/**
 * Where this skin is mounted, in one place.
 *
 * Screens used to hard-code `/ofertas`, which meant the skin knew its own mount
 * point and every link had to be found and edited to move it. The shell owns the
 * prefix; the skin builds its paths from it. Moving the product to another path
 * is now a one-line change here, not a search across screens.
 */
export const PENCIL_BASE = "/pencil";

export const routes = {
  base: PENCIL_BASE,
  panel: `${PENCIL_BASE}/panel`,
  ofertas: `${PENCIL_BASE}/ofertas`,
  ofertaNueva: `${PENCIL_BASE}/ofertas/nueva`,
  oferta: (jobId: string) => `${PENCIL_BASE}/ofertas/${jobId}`,
  ofertaEditar: (jobId: string) => `${PENCIL_BASE}/ofertas/${jobId}/editar`,
  buscar: `${PENCIL_BASE}/buscar`,
  tecnico: (profileId: string) => `${PENCIL_BASE}/tecnicos/${profileId}`,
  agenda: `${PENCIL_BASE}/agenda`,
  mensajes: `${PENCIL_BASE}/mensajes`,
  /** Messages with the thread for one (offer, technician) already open, so the
      producer can go from the roster to the conversation without hunting for
      it in the list. */
  mensajesCon: (jobId: string, technicianProfileId: string) =>
    `${PENCIL_BASE}/mensajes?oferta=${encodeURIComponent(jobId)}&tecnico=${encodeURIComponent(technicianProfileId)}`,
  resenas: `${PENCIL_BASE}/resenas`,
  /** Offers list filtered by a free-text query (the top-bar search). */
  ofertasBuscando: (term: string) =>
    term ? `${PENCIL_BASE}/ofertas?q=${encodeURIComponent(term)}` : `${PENCIL_BASE}/ofertas`,
} as const;

/** The flat paths this product used before it was namespaced. Kept so links
    shared or bookmarked while the app was live keep working; the shell turns
    each into a redirect. */
export const LEGACY_REDIRECTS: ReadonlyArray<readonly [from: string, to: string]> = [
  ["/panel", routes.panel],
  ["/ofertas", routes.ofertas],
  ["/ofertas/nueva", routes.ofertaNueva],
  ["/buscar", routes.buscar],
  ["/agenda", routes.agenda],
  ["/mensajes", routes.mensajes],
  ["/resenas", routes.resenas],
];
